import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
import Styles from 'src/components/Styles';

function ScanMarketCard() {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
      <Path
        d="M19 6.5c.275 0 .5.225.5.5v1h-15V7c0-.275.225-.5.5-.5h14zm.5 4.5v6c0 .275-.225.5-.5.5H5a.501.501 0 01-.5-.5v-6h15zM5 5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2H5zm1.75 9.5a.748.748 0 00-.75.75c0 .416.334.75.75.75h1.5c.416 0 .75-.334.75-.75a.748.748 0 00-.75-.75h-1.5zm4 0a.748.748 0 00-.75.75c0 .416.334.75.75.75h3.5c.416 0 .75-.334.75-.75a.748.748 0 00-.75-.75h-3.5z"
        fill={Styles.Colors.PayNew.black01}
      />
    </Svg>
  );
}

const ScanMarketCardIcon = React.memo(ScanMarketCard);

export default ScanMarketCardIcon;
